module.exports = __webpack_public_path__ + "static/media/umrah-package-3.0765cef5.jpg";